import React from 'react';

import CoreUtils from '../../common/utils/CoreUtils';

import DataModelView from '../../common/view/DataModelView';

export default class CarbonFreeSummaryView extends DataModelView {
  getIntegratedPropertyNames() {
    return [
      'counterparty',
      'contracts',
      'totalCFAllocation',
      'totalCFDelivered',
      'totalCFRemaining'
    ];
  }

  render() {
    return (
      <div>
        <div className="dx-fieldset">
          <div className="dx-fieldset-header">{formatStringProperty(this.state.counterparty, 'displayName')}</div>
          <div className="dx-fieldset-subheader">CARBON FREE SCHEDULING (TAGGED)</div>
          <div className={resolveAlertClass('dx-field', this.state.totalCFAllocation === null)}>
            <div className="dx-field-label">Total (MWh)</div>
            <div className="dx-field-value-static">{formatNullableNumber(this.state.totalCFAllocation, this.props.locale)}</div>
          </div>
          <div className={resolveAlertClass('dx-field', this.state.totalCFDelivered === null)}>
            <div className="dx-field-label">Delivered (MWh)</div>
            <div className="dx-field-value-static">{formatNullableNumber(this.state.totalCFDelivered, this.props.locale)}</div>
          </div>
          <div className={resolveAlertClass('dx-field', this.state.totalCFRemaining === null)}>
            <div className="dx-field-label">Remaining (MWh)</div>
            <div className="dx-field-value-static">{formatNullableNumber(this.state.totalCFRemaining, this.props.locale)}</div>
          </div>
        </div>
      </div>
    );
  }
}

function resolveAlertClass(primaryClassName, isAlertVisible) {
  return primaryClassName + (isAlertVisible ? ' pwx-alert' : '');
}

function formatNullableNumber(value, locale) {
  return CoreUtils.isDefinedAndNotNull(value)
    ? value.toLocaleString(locale)
    : 'N/A';
}

function formatStringProperty(component, dataField) {
  return CoreUtils.isDefinedAndNotNull(component)
    ? component[dataField]
    : '';
}